module.exports = __webpack_public_path__ + "img/upload_btn.b975a439.png";